import React, { useEffect, useState } from "react";
import { Table, Input, Button } from "reactstrap";
import { getTeams, addTeam, editTeam, deleteTeam, getUsers } from "helpers/fakebackend_helper";
import AddEditTeamModal from "./AddEditTeamModal";

const TeamsTable = ({ token }) => {
    const [teams, setTeams] = useState([]);
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [expandedTeamIds, setExpandedTeamIds] = useState([]);
    const [modal, setModal] = useState(false);
    const [editingTeam, setEditingTeam] = useState(null);
    const [selectedMemberIds, setSelectedMemberIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [done, setDone] = useState(false);
    const [page, setPage] = useState(1);
    const [error, setError] = useState("");

    const pageSize = 5;

    const loadTeams = async () => {
        const { data } = await getTeams(token);
        setTeams(data);
    };

    const loadUsers = async () => {
        const { data } = await getUsers(token);
        setUsers(data);
    };

    useEffect(() => {
        loadTeams();
        loadUsers();
    }, []);

    const filtered = teams.filter((t) => t.team_name.toLowerCase().includes(search.toLowerCase()));
    const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);
    const totalPages = Math.ceil(filtered.length / pageSize);

    const toggleExpand = (id) => {
        setExpandedTeamIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const handleSave = async () => {
        setError("");
        setIsSaving(true);

        try {
            if (editingTeam?.id) {
                const res = await editTeam(token, {
                    ...editingTeam,
                    team_member_ids: selectedMemberIds
                });
            } else {
                const res = await addTeam(token, editingTeam);
            }

            setIsSaving(false);
            setDone(true);
            setTimeout(() => {
                setDone(false);
                setModal(false);
                setEditingTeam(null);
                setSelectedMemberIds([]);
                loadTeams();
            }, 1200);
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || "Unexpected error");
            setIsSaving(false);
        }
    };

    const toggleModal = () => {
        setModal(!modal);
        setEditingTeam(null);
        setSelectedMemberIds([]);
        setError("");
        setIsSaving(false);
        setDone(false);
    };


    return (
        <div>
            <div className="d-flex mb-3">
                <Input
                    placeholder="Search team name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <Button
                    color="primary"
                    className="ms-2"
                    onClick={() => {
                        setEditingTeam({});
                        setSelectedMemberIds([]);
                        setModal(true);
                    }}
                >
                    Add Team
                </Button>
            </div>

            <div className="overflow-x-auto">
                <Table hover>
                    <thead>
                        <tr>
                            <th>Team Name</th>
                            <th>Team Leader</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginated.map((t) => (
                            <React.Fragment key={t.id}>
                                <tr>
                                    <td onClick={() => toggleExpand(t.id)} style={{ cursor: "pointer" }}>
                                        {t.team_name}
                                    </td>
                                    <td>{t.team_leader.full_name}</td>
                                    <td>
                                        <Button size="sm" color="info" onClick={() => {
                                            setEditingTeam(t);
                                            setSelectedMemberIds(t.team_members.map(m => m.user_id.toString()));
                                            setModal(true);
                                        }}>
                                            Edit
                                        </Button>{" "}
                                        <Button size="sm" color="danger" onClick={async () => { await deleteTeam(token, { id: t.id }); loadTeams(); }}>
                                            Delete
                                        </Button>
                                    </td>
                                </tr>

                                {expandedTeamIds.includes(t.id) && (
                                    <tr>
                                        <td colSpan="3" className="bg-light p-2">
                                            <Table size="sm" className="mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Member</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {t.team_members.map((tm, i) => {
                                                        const member = users.find(u => u.id === tm.user_id);
                                                        return (
                                                            <tr key={tm.id}>
                                                                <td>{i + 1}</td>
                                                                <td>{member?.full_name || "Unknown"}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-end gap-2 mt-2">
                <Button size="sm" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</Button>
                <span>{page} / {totalPages}</span>
                <Button size="sm" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next</Button>
            </div>

            <AddEditTeamModal
                isOpen={modal}
                toggle={toggleModal}
                editingTeam={editingTeam}
                setEditingTeam={setEditingTeam}
                users={users}
                selectedMemberIds={selectedMemberIds}
                setSelectedMemberIds={setSelectedMemberIds}
                handleSave={handleSave}
                isSaving={isSaving}
                done={done}
                error={error}
            />
        </div>
    );
};

export default TeamsTable;